import { render, staticRenderFns } from "./HomeAlphaWidget.vue?vue&type=template&id=2cc0999b&"
import script from "./HomeAlphaWidget.vue?vue&type=script&lang=js&"
export * from "./HomeAlphaWidget.vue?vue&type=script&lang=js&"
import style0 from "./HomeAlphaWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports